import { onMounted, onUnmounted, ref } from 'vue'

export interface KeyboardShortcut {
  key: string
  action: () => void
  description: string
  preventDefault?: boolean
}

export function useKeyboardShortcuts(shortcuts: KeyboardShortcut[]) {
  const isHelpOpen = ref(false)

  const handleKeyPress = (event: KeyboardEvent) => {
    // Don't trigger shortcuts when typing in input fields
    const target = event.target as HTMLElement
    if (
      target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA' ||
      target.contentEditable === 'true'
    ) {
      return
    }

    // Handle help overlay toggle
    if (event.key === '?') {
      event.preventDefault()
      isHelpOpen.value = !isHelpOpen.value
      return
    }

    // Handle escape to close help
    if (event.key === 'Escape' && isHelpOpen.value) {
      event.preventDefault()
      isHelpOpen.value = false
      return
    }

    // Find and execute matching shortcut
    const shortcut = shortcuts.find((s) => s.key.toLowerCase() === event.key.toLowerCase())
    if (shortcut) {
      if (shortcut.preventDefault !== false) {
        event.preventDefault()
      }
      shortcut.action()
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyPress)
  })

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeyPress)
  })

  return {
    isHelpOpen,
    shortcuts
  }
}
